// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n#header[data-v-3553893d] {\n  float: right;\n}\n#title[data-v-3553893d] {\n  padding: 10px;\n}\n#backBtn[data-v-3553893d] {\n  float:right;\n}\n#register_button[data-v-3553893d] {\n  margin-top: 30px;\n}\n.radio_label[data-v-3553893d] {\n  margin-left: 0.5rem;\n}\n.alert-margin[data-v-3553893d]{\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
